import { type UploadUrlResponse } from "../api/upload";
import { waitForMs } from "../helpers/await";

export async function uploadFile(): Promise<void> {
  await waitForMs(3000);
}

export async function getUploadUrl(): Promise<UploadUrlResponse> {
  return Promise.resolve({
    url: "https://upload.url",
    fields: {
      key: "file-key",
      bucket: "file-bucket",
      "X-Amz-Algorithm": "file-algorithm",
      "X-Amz-Credential": "file-credential",
      "X-Amz-Date": "file-date",
      "X-Amz-Security-Token": "file-security-token",
      Policy: "file-policy",
      "X-Amz-Signature": "file-signature"
    }
  });
}
